import classnames from 'classnames';
import React from 'react';
import addReactionAsset from '../../../../../assets/img/add-reactions.svg';
import styles from './emoji-picker-button.module.scss';

export const EmojiPickerButton = ({ onClick, isOpen = false }) => {
  return (
    <div
      className={classnames(styles.addReactionContainer, {
        [styles.selected]: isOpen,
      })}
    >
      <img
        src={addReactionAsset}
        onClick={() => {
          onClick && onClick();
        }}
        alt="Add reaction"
      />
    </div>
  );
};
